import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { AppState } from '../../../../store';
import Divider from '@mui/material/Divider';
import IncDecQuantity from '../ProductLists/ProductListItems/ProductDetails/Quantity';
import Price from '../../../../common/Price'
import Bazzskelton from '../../../../common/BazzSkelton';
import { calculateTotalDiscount, calculateTotalPrice, calculatePrice, getTomorrowsDate } from '../../../../utils';
import { CART_ADD_ITEM, CART_REMOVE_ITEM } from '../../../../constants/cartConstants';
import { useCommonStyles } from '../../../../common/common';
import EmptyCartMessage from './EmptyCart';

export const Item = styled(Paper)(({ theme }) => ({
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));

export default function AddToCart(props: any) {
	const commonClasses = useCommonStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const { cartItems } = useSelector<AppState, AppState['cart']>(
        ({cart}) => cart,
    );
	const { loading } = useSelector<AppState, AppState['common']>(
		({ common }) => common,
	);

	const onIncDecQuantityClick = (item: any, action: string) => {
		dispatch({
			type: CART_ADD_ITEM,
			payload: {
			  name: item.name,
			  description: item.description,
			  image: item.image,
			  brand: item.brand,
			  price: item.price,
			  countInStock: item.countInStock,
			  product: item.product,
			  seller: item.seller,
			  qty: action === '+' ? item.qty + 1 : item.qty - 1,
			},
		});
	}

	const removeCartItem = (productId: string) => {
		dispatch({ type: CART_REMOVE_ITEM, payload: productId })
	}

	const placeOrderNow = () => {
		history.push('/checkout')
	}

	return (
		<Box className={commonClasses.mainContainer}>
			{/* Loading */}
			{loading && <Bazzskelton list={[1,2]} />}
			{/* Products list */}
			{!loading && <Box style={{padding: '32px', paddingTop: '16px', minHeight: '60vh'}}>
				<Box sx={{ flexGrow: 1 }}>
                    <Box component="h5"><b>My Cart({(cartItems && cartItems.length) || 0})</b></Box>
					<Grid container spacing={0}>
						<Box width="100%" display="flex" alignItems="center" flexDirection="column" justifyContent="center">
							{(!cartItems || cartItems.length === 0) &&
								<EmptyCartMessage />
							}
						</Box>
						<Grid item xs={12} sm={8}>
							{cartItems && cartItems.length > 0 && cartItems.map((item: any) => 
								<Item style={{textAlign: 'left', padding: '18px', boxShadow: 'none', border: '1px solid #ccc', marginBottom: '1vh'}}>
									<Box display="flex" flexDirection="row">
										<Box display="flex" flexDirection="column">
											<img
												src={`${item.image}`}
												alt={item.name}
												loading="lazy"
												style={{ width: '120px', height: '144px'}}
											/>
											<Box display="flex" flexDirection="row">
												<IncDecQuantity
													totalQuantity={item.qty}
													item={item}
													onIncDecQuantityClick={onIncDecQuantityClick}
												/>
											</Box>
										</Box>
										<Box flex={1} display="flex" flexDirection="column" ml={2}>
											<Box component="h6" display="flex" justifyContent="space-between">
												<span><b>Product name:</b> {item.name}</span>
												<span>Delivery by {getTomorrowsDate(5)} | <span style={{color: '#388e3c'}}>Free </span><del>₹40</del></span>
											</Box>
											<Box component="h6"><b>Description:</b> {item.description}</Box>
											<Box component="h6"><b>Brand:</b> {item.brand}</Box>
											<Box component="h6"><b>Seller:</b> {item.seller.seller.name}</Box>
											<Box component="h6" display="flex"><b>Price:</b>&nbsp;<Price price={item.price} /></Box>
											<Box display="flex">
												<Button
													color="error"
													variant="outlined" size="small"
													style={{ margin: '8px'}}
													onClick={() => removeCartItem(item.product)}
												>
													Remove
												</Button>
											</Box>
										</Box>
									</Box>
								</Item>
							)}
							{cartItems && cartItems.length > 0  && <Item 
									sx={{ boxShadow: 'none'}}>
								<Box
									display='flex'
									flexDirection='row'
									justifyContent="flex-end"
								>
									<Button
										style={{ color: '#fff', background: 'linear-gradient(180deg, #C12902 67.71%, #E76240 100%)'}}
										color="secondary"
										variant="outlined"
										onClick={() => placeOrderNow()}
									>
										Place Order Now
									</Button>
								</Box>
							</Item>}
						</Grid>
						{ cartItems && cartItems.length > 0 && <Grid item xs={12} sm={4}>
							<Item  sx={{textAlign: 'left', padding: '18px', boxShadow: 'none'}}>
								<Box display="flex" flexDirection="column">
									<Box component="h5"><b>Price Details</b></Box>
									<Divider sx={{marginBottom: '12px'}} />
									<Box display="flex" component="h6" flexDirection="column">
										<Box component="h6" display="flex" justifyContent="space-between"><b>Price({cartItems.length} items):</b> ₹{calculatePrice(cartItems)}</Box>
										<Box component="h6" display="flex" justifyContent="space-between"><b>Discount:</b> <Box sx={{color: '#388e3c'}}>-₹{calculateTotalDiscount(cartItems)}</Box></Box>
										<Box component="h6" display="flex" justifyContent="space-between"><b>Delivery Charges:</b> <Box sx={{color: '#388e3c'}}>Free</Box></Box>
										<Divider sx={{marginBottom: '12px'}} />
										<Box component="h6" display="flex" justifyContent="space-between"><b>Total price:</b> <b>₹{calculateTotalPrice(cartItems)}</b></Box>
										<Divider sx={{marginBottom: '12px'}} />
										<Box component="h6" sx={{color: '#388e3c', fontWeight: 'bold'}}>You will save ₹{calculateTotalDiscount(cartItems)} on this order.</Box>
									</Box>
								</Box>
							</Item>
						</Grid>}
					</Grid>
				</Box>
			</Box>}
		</Box>
	);
}
